import React from 'react';
import styled from 'styled-components';
import { useCallbackUrl } from '../hooks/mutations';

export const FakeLoginView = () => {

    const callbackURL = useCallbackUrl();
    const href = `/auth/sign-in/fake?callbackURL=${encodeURIComponent(callbackURL)}`;

    return <FakeUserLink href={href}>Continue as Fake User</FakeUserLink>;
};

const FakeUserLink = styled.a`
    display: block;
    text-align: center;
    font-size: 0.8125rem;
    color: #6b7280;
    margin-top: 0.75rem;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
